// PawShop Theme JS v3 — Conversion Optimized

// ── NOTIFICATION ──
function showNotif(msg, type) {
  const el = document.getElementById('cart-notification');
  if (!el) return;
  el.textContent = msg;
  el.className = 'cart-notification visible' + (type === 'success' ? ' success' : '');
  setTimeout(() => el.classList.remove('visible'), 3000);
}

// ── PANIER AJAX ──
async function addToCartShopify(variantId, qty) {
  qty = qty || parseInt(document.getElementById('qty-input') ? document.getElementById('qty-input').value : 1) || 1;
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    const item = await res.json();
    if (item.status === 422) { showNotif('Produit indisponible', 'error'); return; }
    updateCartCount();
    showNotif('✓ ' + item.title + ' ajouté !', 'success');
    const btn = document.querySelector('.btn-add.active-btn');
    if (btn) { btn.textContent = '✓'; btn.classList.add('added'); setTimeout(() => { btn.textContent = '+'; btn.classList.remove('added'); }, 2000); }
  } catch (e) { console.error(e); }
}

async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const count = cart.item_count;
    document.querySelectorAll('.cart-badge').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    updateShippingBar(cart.total_price / 100);
  } catch (e) {}
}

function updateShippingBar(total) {
  const threshold = 49;
  const pct = Math.min(100, Math.round((total / threshold) * 100));
  document.querySelectorAll('.shipping-fill').forEach(el => el.style.width = pct + '%');
  document.querySelectorAll('.shipping-text').forEach(el => {
    if (total >= threshold) {
      el.innerHTML = '<strong style="color:var(--green)">🎉 Livraison gratuite débloquée !</strong>';
    } else {
      el.innerHTML = 'Plus que <strong>' + (threshold - total).toFixed(0) + ' €</strong> pour la livraison gratuite 🚚';
    }
  });
}

// ── MENU MOBILE ──
function toggleMobileMenu() {
  const nav = document.getElementById('mobile-nav');
  if (nav) nav.classList.toggle('open');
}

// ── FILTRES CATÉGORIE ──
function filterCategory(cat, btn) {
  document.querySelectorAll('.cat-btn').forEach(b => b.classList.remove('active'));
  if (btn) btn.classList.add('active');
  document.querySelectorAll('.product-card[data-category]').forEach(card => {
    card.style.display = (cat === 'all' || card.dataset.category === cat) ? '' : 'none';
  });
}

// ── VARIANTES ──
function selectVariant(optName, value, variantId) {
  document.querySelectorAll('[data-opt="' + optName + '"]').forEach(el => {
    el.classList.toggle('selected', el.dataset.value === value);
  });
  const input = document.getElementById('variant-id');
  if (input && variantId) input.value = variantId;
}

// ── IMAGES PRODUIT ──
function switchImage(src) {
  const main = document.getElementById('main-product-image');
  if (main) { main.style.opacity = '0.6'; main.src = src; main.onload = () => main.style.opacity = '1'; }
}

// ── WISHLIST ──
function toggleWishlist(btn) {
  const liked = btn.classList.toggle('liked');
  btn.textContent = liked ? '❤️' : '🤍';
  showNotif(liked ? '❤️ Ajouté aux favoris' : 'Retiré des favoris', 'success');
}

// ── QUANTITÉ ──
function changeQty(delta) {
  const input = document.getElementById('qty-input');
  if (!input) return;
  const val = Math.max(1, (parseInt(input.value) || 1) + delta);
  input.value = val;
}

// ── STICKY ATC ──
function initStickyAtc() {
  const atcBtn = document.querySelector('.product-actions .btn-primary');
  const sticky = document.getElementById('sticky-atc');
  if (!atcBtn || !sticky) return;
  const observer = new IntersectionObserver(entries => {
    sticky.classList.toggle('visible', !entries[0].isIntersecting);
  }, { threshold: 0 });
  observer.observe(atcBtn);
}

// ── COUNTDOWN ──
function initCountdown(selector, seconds) {
  const el = document.querySelector(selector);
  if (!el) return;
  let s = seconds;
  (function tick() {
    if (s <= 0) return;
    const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    el.textContent = [h, m, sec].map(v => String(v).padStart(2, '0')).join(':');
    s--;
    setTimeout(tick, 1000);
  })();
}

// ── RECENTLY VIEWED (localStorage simulé en session) ──
function trackProduct(id, title, price, img, url) {
  try {
    let viewed = JSON.parse(sessionStorage.getItem('paw_viewed') || '[]');
    viewed = viewed.filter(p => p.id !== id);
    viewed.unshift({ id, title, price, img, url });
    sessionStorage.setItem('paw_viewed', JSON.stringify(viewed.slice(0, 6)));
  } catch(e) {}
}

// ── INIT ──
document.addEventListener('DOMContentLoaded', () => {
  updateCartCount();
  initStickyAtc();
  // Countdown 4h sur page produit
  initCountdown('.countdown-timer', 4 * 3600 + Math.floor(Math.random() * 1800));
  // Lien actif nav
  const path = window.location.pathname;
  document.querySelectorAll('.nav-link').forEach(link => {
    if (link.getAttribute('href') === path) link.classList.add('active');
  });
});
